module.exports = __webpack_public_path__ + "files/a45c6a668e0055a0c6312996e376325d.png";